import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const eld99Config: TSPConfig = {
  key: 'eld99',
  name: 'ELD99',
  imageName: 'ELD99',
  category: TSPCategory.API_KEY,
  helpText: 'Enter your ELD99 API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default eld99Config;
